import QueriesListing from "./queriesListing";

const QueriesManagement = {
  QueriesListing: QueriesListing,
};
export default QueriesManagement;
